export default function() {
  return Array.from(this);
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-hierarchy/src/hierarchy/descendants.js
// module id = 536
// module chunks = 0